import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../role.guard';
import { ProfileConst } from '../utils';
import { LoginComponent } from './login/login.component';
import { RecoverPassword } from './password/recover-password.component';
import { TruckerEnrollmentComponent } from './trucker-enrollment/trucker-enrollment.component';


const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'recover-password', component: RecoverPassword },
    { path: 'trucker-enrollment/:user_key', component: TruckerEnrollmentComponent },
    {
        path: 'sign-up',
        loadChildren: () => import('./sign-up/sign-up.module').then(m => m.SignUpModule)
    },
    {
        path: 'dispatcher-profile-activation',
        loadChildren: () => import('./dispatcher-profile-activation/dispatcher-profile-activation.module').then(m => m.DispatcherProfileActivationModule),
        data: { expectedRoles: [ProfileConst.driver_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
